import * as React from 'react';

export default class WKPage extends React.Component {
  public render() {
    const AppStyle: React.CSSProperties = {
      backgroundColor: 'rgba(240,240,240,1)',
      boxSizing: 'border-box',
      color: '#333',
      display: 'block',
      fontSize: '12px',
      margin: '0 auto',
      maxWidth: '480px',
      minHeight: '100vh',
      position: 'relative'
    };
    return (
      <div className="WKPage" style={AppStyle}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WKPage.tsx